import { useState } from "react";

// Hook para realizar a paginação dos dados vindos da api
export function useFetchPaginatedData(fetchFunction, rowsPerPage = 50, filters = {}) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchAllData = async (overrideFilters = null) => {
        setLoading(true);
        try {
            let allData = [];
            let currentPage = 1;
            let totalPages = 1;

            const appliedFilters = overrideFilters !== null ? overrideFilters : filters;

            while (currentPage <= totalPages) {
                // Passe os filtros para a função de busca
                const response = await fetchFunction(currentPage, rowsPerPage, appliedFilters);

                if (response?.items) {
                    allData = [...allData, ...response.items];
                }

                if (currentPage === 1) {
                    totalPages = Math.ceil(response.totalItems / rowsPerPage);
                }

                currentPage++;
            }

            setData(allData);
            return allData;
        } catch (error) {
            console.error("Erro ao buscar dados paginados:", error);
        } finally {
            setLoading(false);
        }
    };

    return {
        data,
        loading,
        fetchAllData, // Aceita filtros dinâmicos: fetchAllData({nome: "Teste"})
        setData
    };
}
